import { createSlice } from "@reduxjs/toolkit";
import { IAppSlice } from "../../../models/master/apps";


const initialAppState: IAppSlice = {
  apps:undefined,
  app:undefined,
  appsForTerm:undefined
};

const appSlice = createSlice({
  name: "app",
  initialState: initialAppState,
  reducers: {
    setApps: (state, action: { payload: any }) => {
      state.apps = action.payload;
    },
    setAppsForTerm: (state, action: { payload: any }) => {
      state.appsForTerm = action.payload;
    }, 
    setApp: (state, action: { payload: any }) => {
      state.app = action.payload;
    },
    
  },
});

export const { setApps, setAppsForTerm, setApp } =
  appSlice.actions;

const appsReducer = appSlice.reducer;

export type appState = ReturnType<typeof appsReducer>;

export default appsReducer;
